import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import "./RenewExitConfirm.css";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => Promise<void> | void;
};

export default function RenewExitConfirm({ open, onClose, onConfirm }: Props) {
  const [exiting, setExiting] = useState(false);
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const handleExit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      if (onConfirm) await onConfirm();
    } catch (e) {
      console.error("Exit confirm failed", e);
    } finally {
      setExiting(false);
      navigate("/home");
    }
  };

  if (!open) return null;

  return (
    <div
      className="renew-exit-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Exit confirmation"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          maxWidth: 420,
          width: "100%",
          padding: "20px 20px 16px",
          boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: 15,
            fontWeight: 750,
            color: "#1a2e2c",
            lineHeight: 1.3,
          }}
        >
          {_t("exitForNow", "Exit for now?")}
        </h3>
        <p
          style={{
            margin: "8px 0 0",
            fontSize: 13,
            color: "#5a6b68",
            lineHeight: 1.45,
          }}
        >
          {_t(
            "exitRenewDescription",
            "Your progress is saved. Your profile will stay expired until you finish updating it."
          )}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 18,
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "#fff",
              border: "1px solid #d9e0de",
              borderRadius: 999,
              padding: "9px 18px",
              fontSize: 14,
              fontWeight: 600,
              color: "#1a2e2c",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            {_t("keepGoing", "Keep going")}
          </button>
          <button
            type="button"
            onClick={handleExit}
            disabled={exiting}
            style={{
              background: "#1a2e2c",
              border: "1px solid #1a2e2c",
              borderRadius: 999,
              padding: "9px 18px",
              fontSize: 14,
              fontWeight: 700,
              color: "#fff",
              cursor: exiting ? "wait" : "pointer",
              lineHeight: 1,
              opacity: exiting ? 0.7 : 1,
            }}
          >
            {_t("exit", "Exit")}
          </button>
        </div>
      </div>
    </div>
  );
}
